module.exports = __webpack_public_path__ + "img/account.9affb9d.png";